import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import IntendedUseApiRequest from "Communication/ApiClasses/IntendedUseApiRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleIntendedUse() {
  yield put(doLoadingStart(STRINGS.ACCOUNT_INFORMATION.API_KEYS.INTENDED_USE));
  const intendedUseApi = new IntendedUseApiRequest();
  try {
    const result = yield call(intendedUseApi.getData);
    yield put({
      type: actionTypes.ADD_INTENDED_USE,
      intendedUseList: result.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.INTENDED_USE_ERROR,
      error: error.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.ACCOUNT_INFORMATION.API_KEYS.INTENDED_USE)
    );
  }
}

// watcher
export default function* countryWatcherSaga() {
  yield takeLatest(actionTypes.GET_INTENDED_USE, handleIntendedUse);
}
